import styled , {css} from 'styled-components';
import { DisplacementTransition } from '../../../components/loggedout/shared-styles/transitions';
import { device } from '../../../utils/responsive_utilities';
import { melrose , dullPurple } from '../../shared-styles/Colors';

export const ChildNameContainer = styled.div`
  padding-top: 7.4rem;
  @media ${device.Tablet}{
    padding-top: 13.5rem;
  }
  @media ${device.PhoneTabletLandscape} {
    padding-top: 5.4rem;
  }
  @media ${device.Phone} {
    padding-top: 8.7rem;
  }
`;

export const UlListContainer = styled.div`
      margin: 0 auto;
      width: 44rem;
      li {
        display: block;
        width: 40.6rem;
        min-height: 5.6rem;
        border-radius: 3.2rem;
        border: 0.1rem solid ${melrose};
        font-weight: 600;
        line-height: 5.8rem;
        font-size: 2rem;
        font-stretch: normal;
        font-style: normal;
        margin-bottom: 1.5rem;
        :hover {
          cursor: pointer;
        }

        span {
          color: ${dullPurple};
        }
      }
`;